import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";


function AddContact({ onClose, company_id, onSuccess }) {
const { register, handleSubmit, watch, setValue, formState:{ errors } } = useForm();
const navigate = useNavigate();
const { setGlobalLoading, token } = useOutletContext();
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;

  setValue("company_id",company_id);
  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/orders/add_new_contact`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Contact update successfully!");
     if (typeof onSuccess === "function") { onSuccess();}
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 

return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Add New Contact</h4>
                <input type="hidden" {...register("company_id")} />
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
                <div className="row">
                    <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                        <label className="form-label">First Name *</label>
                        <input type="text" {...register("firstname", { required: true })} className={`form-control ${ errors.firstname && "is-invalid"}`}/>
                        </div>

                        <div className="mb-2">
                        <label className="form-label">Phone *</label>
                        <input type="text" {...register("phone", { required: true })} className={`form-control ${ errors.phone && "is-invalid"}`} />
                        </div>

                        <div className="mb-2">
                        <label className="form-label">Designation *</label>
                        <input type="text" {...register("designation", { required: true })} className={`form-control ${ errors.designation && "is-invalid"}`} />
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                        <label className="form-label">Last Name *</label>
                        <input type="text" {...register("lastname", { required: true })} className={`form-control ${ errors.lastname && "is-invalid"}`} />
                        </div>

                        <div className="mb-2">
                        <label className="form-label">Email *</label>
                        <input type="text" {...register("email")} className={`form-control ${ errors.email && "is-invalid"}`} />
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12">
                        <div className="mb-2">
                            <label className="form-label">Address *</label>
                            <input type="text" {...register("address")} className={`form-control ${ errors.address && "is-invalid"}`} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>  
);    
}
export default AddContact;